angular.module('gestioneAttiApp').directive('rispostaScrittaBlock', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/rispostaScrittaBlock/rispostaScrittaBlock.html',
        scope: {
            atto: '=',
            statoAttoCorrente: '=',
            statoPresentatoCollapsed: '=',
            courtOutcome: '=',
            isProtocollo: '=',
            isSettoreAtti: '=',
            utente: "=",
            docTypes: "=",
            changeDocumentTypeCallback: "=",
            changeDocumentVisibilityCallback: "=",
            changeDocumentFrontpieceCallback: '=',
            publicView: "=",
            hideEsitoAttoMedatati: "=",
            viewMode: '='
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: ['Atto', 'User', 'PdlService', 'Documento', '$location','$anchorScroll', '$timeout', function (Atto, User, PdlService, Documento, $location, $anchorScroll, $timeout) {
            var vm = this;
            vm.clearRadio = PdlService.clearRadio;
            vm.attoRitiratoDocs = [];
            vm.sezioni = {
                COURT_OUTCOME: {
                    form: (vm.atto.tipoAtto === 'IO' || vm.atto.tipoAtto === 'IS')
                            ? 'app/components/courtroomBlock/io.courtroomOutcome.html'
                            : 'app/components/courtroomBlock/courtroomOutcome.html'
                }
            };

            vm.stato = {
                rispostaScritta: {
                    isCollapsed: vm.statoAttoCorrente === 'RISPOSTA_SCRITTA' || vm.viewMode
                }
            };

            vm.getSezioniFromMap = PdlService.getSezioniFromMap;
            vm.invalidFields = vm.invalidFields || [];

        }]
    };
});
